(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2197],{

/***/ 51126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _404; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Footer/Footer.tsx + 1 modules
var Footer = __webpack_require__(90359);
// EXTERNAL MODULE: ./src/components/Header/Header.tsx + 2 modules
var Header = __webpack_require__(50866);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/Button/Button.tsx + 1 modules
var Button = __webpack_require__(83537);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(41686);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/NotFoundError/NotFoundError.elements.tsx




var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "NotFoundErrorelements__Wrapper",
  componentId: "sc-109wasy-0"
})(["display:flex;flex-direction:column;align-items:center;margin-top:", ";@media (min-width:", "px){margin-top:", ";}"], (0,polished_esm/* rem */.hO)(constants/* MOBILE_HEADER_HEIGHT */.ZQ), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(constants/* DESKTOP_HEADER_HEIGHT */.cf));
var Title = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "NotFoundErrorelements__Title",
  componentId: "sc-109wasy-1"
})(["font-size:", ";font-weight:", ";color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSizes.h1;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textBold;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.primary;
});
var SubTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "NotFoundErrorelements__SubTitle",
  componentId: "sc-109wasy-2"
})(["padding:", " 0 ", " 0;font-size:", ";font-weight:", ";"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(15), function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSizes.h6;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontWeights.textBold;
});
var Description = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "NotFoundErrorelements__Description",
  componentId: "sc-109wasy-3"
})(["text-align:center;line-height:", ";"], (0,polished_esm/* rem */.hO)(24));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/NotFoundError/NotFoundError.tsx









var NoteFoundErrorTemplate = function NoteFoundErrorTemplate() {
  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var router = (0,next_router.useRouter)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
      children: t('error.404.title')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SubTitle, {
      children: t('error.404.subTitle')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
      dangerouslySetInnerHTML: {
        __html: t('error.404.description')
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
      onClick: function onClick() {
        return router.replace({
          pathname: constants/* ROUTES.HOME */.Z6.HOME
        });
      },
      marginTop: 40,
      marginBottom: 40,
      text: t('error.404.button')
    })]
  });
};

/* harmony default export */ var NotFoundError = (NoteFoundErrorTemplate);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
;// CONCATENATED MODULE: ./src/pages/404.tsx










var NotFound = function NotFound() {
  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Content/* default */.Z, {
      withPadding: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(NotFoundError, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
};

/* harmony default export */ var _404 = (NotFound);

/***/ }),

/***/ 6141:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(51126);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 77191:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectDestructuringEmpty; }
/* harmony export */ });
function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
}

/***/ }),

/***/ 90116:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(52587);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,arrayLikeToArray/* default */.Z)(arr);
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/iterableToArray.js
var iterableToArray = __webpack_require__(28811);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(2937);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,iterableToArray/* default */.Z)(arr) || (0,unsupportedIterableToArray/* default */.Z)(arr) || _nonIterableSpread();
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5897,9774,2888,179], function() { return __webpack_exec__(6141); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);